import styled from "styled-components"
import { desktop } from "components/_blueprint/Layout"

export const SectionCard = styled.section<{ columns?: 1 | 2 }>(({ columns = 2 }) => ({
  background: "white",
  width: "100%",
  maxWidth: "1100px",
  borderRadius: "24px",
  padding: "24px",
  margin: "32px 0",
  display: "flex",
  flexDirection: "column",
  gap: "24px",

  [desktop]: {
    padding: "40px",
    display: "grid",
    gridTemplateColumns: columns === 2 ? "1.4fr 1fr" : "none",
    alignItems: "center",
    gap: "32px",
  },
}))

export const Pill = styled.div(({ theme }) => ({
  display: "flex",
  padding: "8px 12px",
  alignItems: "flex-start",
  gap: "8px",
  borderRadius: "8px",
  background: theme.colors.yellow[500],
  width: "fit-content",
  fontSize: "14px",
  fontWeight: 600,
  color: theme.colors.neutral[900],
}))

export const SectionContent = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "16px",

  [desktop]: {
    width: "100%",
    justifyContent: "center",
    gap: "10px",
  },
})

export const SectionTitle = styled.h2(({ theme }) => ({
  fontSize: "20px",
  fontWeight: 600,
  color: theme?.shade?.["0"] || "#3F4148",
  margin: "12px 0",
  lineHeight: 1.3,

  [desktop]: {
    fontSize: "24px",
    margin: "16px 0",
  },
}))

export const SectionText = styled.p(({ theme }) => ({
  fontSize: "14px",
  color: theme?.shade?.["20"] || "#3B4258",
  lineHeight: 1.7,
  fontWeight: 500,
  margin: "0",

  [desktop]: {
    fontSize: "15px",
  },
}))

export const SectionIllustration = styled.div({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  order: -1,

  img: {
    width: "100%",
    height: "200px",
    borderRadius: "8px",
    objectFit: "cover",
  },

  [desktop]: {
    order: 0,
    img: {
      height: "250px",
    },
  },
})
